var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import { action, observable } from 'mobx';
import { round } from '../helpers/Format';
var TicketPayment = /** @class */ (function () {
    function TicketPayment(paymentMethod) {
        var _this = this;
        this._amount = 0;
        this.receipt = null;
        this.setMethod = function (method) {
            _this._method = method;
        };
        this.setAmount = function (amount) {
            _this._amount = round(amount);
            // this.setMethod(this.method)
        };
        this.setAfiliate = function (afiliate) {
            _this._afiliate = afiliate;
        };
        this._method = paymentMethod;
    }
    Object.defineProperty(TicketPayment.prototype, "afiliate", {
        get: function () {
            return this._afiliate;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(TicketPayment.prototype, "method", {
        get: function () {
            return this._method;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(TicketPayment.prototype, "amount", {
        get: function () {
            return this._amount;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(TicketPayment.prototype, "log", {
        get: function () {
            return this._log;
        },
        set: function (value) {
            this._log = value;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(TicketPayment.prototype, "user", {
        set: function (value) {
            this._user = value;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(TicketPayment.prototype, "user_id", {
        set: function (value) {
            this._user_id = value;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(TicketPayment.prototype, "terminal", {
        set: function (value) {
            this._terminal = value;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(TicketPayment.prototype, "gateway", {
        set: function (value) {
            this._gateway = value;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(TicketPayment.prototype, "token", {
        set: function (value) {
            this._token = value;
        },
        enumerable: false,
        configurable: true
    });
    TicketPayment.prototype.toJSON = function () {
        var log = {
            user: this._user,
            user_id: this._user_id,
            terminal: this._terminal,
            date: new Date().toISOString()
        };
        return {
            method: this._method,
            amount: this._amount,
            receipt: this.receipt,
            afiliate_id: this._afiliate ? this.afiliate.id : null,
            afiliateName: this._afiliate ? this.afiliate.name : null,
            afiliateTypeCommission: this._afiliate ? this.afiliate.typeCommission : null,
            afiliateCommission: this._afiliate ? this.afiliate.commission : null,
            log: log
        };
    };
    __decorate([
        observable
    ], TicketPayment.prototype, "_method", void 0);
    __decorate([
        observable
    ], TicketPayment.prototype, "_amount", void 0);
    __decorate([
        observable
    ], TicketPayment.prototype, "_afiliate", void 0);
    __decorate([
        action
    ], TicketPayment.prototype, "setMethod", void 0);
    __decorate([
        action
    ], TicketPayment.prototype, "setAmount", void 0);
    __decorate([
        action
    ], TicketPayment.prototype, "setAfiliate", void 0);
    return TicketPayment;
}());
export { TicketPayment };
export var PaymentMethod = {
    Due: 'due',
    Cash: 'cash',
    Card: 'card',
    Credit: 'credit',
    Transfer: 'transfer',
    Other: 'other',
    Mixed: 'mixed'
};



//////////////////
// WEBPACK FOOTER
// ./src/Models/TicketPayment.ts
// module id = 332
// module chunks = 0